var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('offline-registration-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabType === 1),expression:"tabType === 1"}],on:{"handleShow":_vm.handleShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }